import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CubesIcon = function CubesIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CubesIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.98 1.292a1.93 1.93 0 0 1 2.039 0l1.89 1.172c.29.18.528.434.692.733.164.3.25.635.25.976v2.458L14.057 8c.29.18.528.434.692.733.165.3.25.635.251.976v2.114c0 .34-.086.677-.25.976-.165.3-.402.552-.693.733l-1.889 1.172a1.93 1.93 0 0 1-.939.29.7.7 0 0 1-.16 0 1.93 1.93 0 0 1-.94-.29L8 13.385l-2.13 1.32a1.93 1.93 0 0 1-.939.29.7.7 0 0 1-.16 0 1.93 1.93 0 0 1-.939-.29l-1.89-1.172a2 2 0 0 1-.691-.733A2.04 2.04 0 0 1 1 11.824V9.71c0-.34.086-.677.25-.976.165-.3.402-.552.693-.733l2.206-1.37V4.173c0-.34.086-.677.25-.976s.402-.552.692-.733zM4.852 7.848 3.038 8.975l1.814 1.128 1.816-1.127zm2.447 2.39-1.744 1.083v1.928l1.744-1.082zm1.404 1.93 1.744 1.08v-1.927l-1.744-1.083zm.63-3.192 1.816 1.127 1.814-1.128-1.813-1.127zm1.114-2.345V4.699L8.702 5.783v1.93zM7.298 7.713v-1.93L5.554 4.7V6.63zM6.187 3.438l1.535-.953a.53.53 0 0 1 .556 0l1.535.953L8 4.566zm7.408 6.798v1.585a.64.64 0 0 1-.077.303.6.6 0 0 1-.202.215m0 0-1.465.91V11.32l1.744-1.084M4.15 13.249V11.32l-1.744-1.084v1.585c0 .108.027.212.077.303s.12.165.202.215m0 0 1.465.91z",
      clipRule: "evenodd"
    })
  }));
};

export { CubesIcon };
